export const CUSTOMER_SUPPORT_URL = 'https://customersupport.checkrpay.com/hc/en-us';
